import React from 'react';
import { Link } from 'react-router-dom'
import { Sparklines, SparklinesLine } from 'react-sparklines';
import _ from 'lodash';
import { db } from '../firebase';
import axios from 'axios';
import SymbolLink from '../components/symbol-link.js'

export default class StockCard extends React.Component {

    constructor() {
        super();
        this.state = {
            symbol: null,
            position: null,
            selectedPeriod: "6m"
        }
        this.onChartPeriodChanged = this.onChartPeriodChanged.bind(this);
    }

    onChartPeriodChanged(period) {

        this.setState({

            selectedPeriod: period
        });
        if (!this.state.position["chart" + period]) {
            this.loadSparklines(period);
        }
    }

    async componentDidMount() {

        this.loadSymbol(this.props.symbol);
    }

    async componentWillReceiveProps(nextProps) {

        if (this.state.symbol != nextProps.symbol) {

            this.loadSymbol(nextProps.symbol);
        }
    }

    async loadSymbol(symbol) {

        if ((!symbol) || symbol.length <= 0) {

            this.setState({
                symbol: null,
                position: null
            });

        }
        else {
            await this.getPosition(symbol);
        }
    }

    async getPosition(symbol) {


        let position_item = await db.getPosition(symbol);
        position_item.unrealized_gains = 0;
        position_item.today_change = 0;
        position_item.today_unrealized_gains = 0;
        this.setState({
            symbol: symbol,
            position: position_item
        });
        let data = await this.getData(symbol);
        this.setState({

            position: data
        });
        this.loadSparklines(this.state.selectedPeriod);
    };

    async  getData(symbol) {

        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=price,quote,stats,company&symbols=' + symbol);
        let position_item = this.state.position;
        position_item.unrealized_gains = 0;
        position_item.last_price = prices && prices.data && prices.data[symbol] ? prices.data[symbol].price : 0;
        position_item.today_unrealized_gains = position_item.last_price > 0 ? ((position_item.last_price - prices.data[symbol].quote.previousClose) * position_item.quantity) : 0;
        position_item.unrealized_gains = position_item.last_price > 0 ? ((position_item.last_price - position_item.price) * position_item.quantity) : position_item.quantity * position_item.price * -1;
        position_item.today_change = prices && prices.data && prices.data[symbol] ? prices.data[symbol].quote.changePercent : 0;
        if (prices.data[symbol]) {

            return {
                ...position_item, ...prices.data[symbol].company
                , ...prices.data[symbol].stats
                , ...prices.data[symbol].quote
                , ...prices.data[symbol].stats
            }


        }
        else {

            return position_item;
        }
    }

    async  loadSparklines(range) {

        let pos_item = this.state.position;
        let chart_data = await axios.get('https://api.iextrading.com/1.0/stock/' + pos_item.symbol + '/chart/' + range);
        if (chart_data && chart_data.data) {

            pos_item["chart" + range] = chart_data.data ? chart_data.data.map(a => { return a.close }) : null;
            this.setState({

                position: pos_item
            });
        }
    }

    render() {

        if (!this.state.position) {
            return <div></div>
        }

        let bcolor = this.state.position.today_unrealized_gains > 0 ? "hsl(141, 71%, 48%)" : "hsl(348, 100%, 61%)";
        let periods = ["5d", "6m", "1y", "5y"];
        let period_changed_callback = this.onChartPeriodChanged;
        let current_period = this.state.selectedPeriod;
        let invested_amount = this.state.position.price * this.state.position.quantity;
        let gain_net = (this.state.position.last_price - this.state.position.price) * this.state.position.quantity;
        let gain_percent = (gain_net * 100 / invested_amount).toFixed(2);

        return (<div style={{ width: "350px", backgroundColor: bcolor }} className="card">
            <header class="card-header">
                <p class="card-header-title">
                    <div class="columns is-gapless  is-mobile" style={{ width: "100%" }}>
                        <div class="column  is-half">
                            <span className="is-size-5  has-text-white">
                                <SymbolLink symbol={this.state.position.symbol} is_white={true} />
                                {/* {this.state.position.symbol} */}
                            </span>
                            <br />
                            <span className="is-size-7  has-text-light">{this.state.position.sector ? this.state.position.sector : "-"}</span>
                        </div>
                        <div class="column">
                            <p className="is-size-5 has-text-white is-pulled-right">${invested_amount.toFixed(2)}</p>
                            <p className="is-size-7 has-text-light is-pulled-right">{gain_percent + '% ( $' + gain_net.toFixed(2) + ')'}</p>
                        </div>
                    </div>
                </p>
            </header>

            <div class="card-content">

                <div class="columns is-gapless  is-mobile" style={{ width: "100%" }}>
                    <div class="column" style={{ textAlign: "center" }}>
                        <p className="has-text-white is-size-6" style={{ margin: 0, fontWeight: "bold" }}>{this.state.position.quantity}</p>
                        <span className="has-text-light  is-size-7"># Shares</span>

                    </div>
                    <div class="column" style={{ textAlign: "center" }}>
                        <p className="has-text-white is-size-6" style={{ margin: 0, fontWeight: "bold" }}>${this.state.position.price.toFixed(2)}</p>
                        <span className="has-text-light  is-size-7">Avg. Price</span>

                    </div>
                    <div class="column" style={{ textAlign: "center" }}>
                        <p className="has-text-white is-size-6" style={{ margin: 0, fontWeight: "bold" }}>
                            ${(this.state.position.last_price).toFixed(2)}
                            &nbsp;({this.state.position.changePercent ? (this.state.position.changePercent * 100).toFixed(1) : '0'}%)
                        </p>
                        <span className="has-text-light  is-size-7">Today's Price</span>

                    </div>
                </div>
                {this.state.position["chart" + current_period] && <div>
                    <Sparklines data={this.state.position["chart" + current_period]}>
                        <SparklinesLine style={{ fill: "white" }} color="white" />
                    </Sparklines>
                </div>}
                {(this.state.position["chart" + current_period] === null || this.state.position["chart" + current_period] === undefined) && <div>
                    <Sparklines data={[0, 0, 0, 0, 0]}>
                        <SparklinesLine style={{ fill: "white" }} color="white" />
                    </Sparklines>
                </div>}
            </div>
            <div class="tabs is-fullwidth" style={{ backgroundColor: "white" }}>
                <ul>
                    {periods.map(a => {

                        return <li class={current_period === a ? "is-active" : ""} onClick={() => period_changed_callback(a)}><a>{a}</a></li>
                    })}

                </ul>
            </div>
            {/* <div>
                <table class="table is-fullwidth is-narrow">
                    <tbody>
                        <tr>
                            <td><span>1.2M</span><br /><span n class="has-text-dark  is-size-7">Volume</span></td>
                            <td><span>6.0B</span><br /><span n class="has-text-dark  is-size-7">Market Cap</span></td>
                            <td><span>6.0B</span><br /><span n class="has-text-dark  is-size-7">Market Cap</span></td>
                        </tr>
                        <tr>
                            <td><span>2.9</span><br /><span n class="has-text-dark  is-size-7">P/E</span></td>
                            <td><span>2%</span><br /><span class="has-text-dark  is-size-7">Div/Yield</span></td>
                            <td><span>6.0B</span><br /><span n class="has-text-dark  is-size-7">Market Cap</span></td>
                        </tr>
                    </tbody>
                </table>
            </div> */}
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/stock-card.js